import Routes from '@/app/routes';

export function App() {
  return <Routes />;
}
